import type { RecipientPersonType as ApiRecipientPersonType } from 'src/api/generated/touring/types';
import { mapLinkableEntityType } from '../../../common';
import type { RecipientPersonType } from '../../types';

export const mapRecipientPersonType = (
  api: ApiRecipientPersonType
): RecipientPersonType => ({
  id: api.id,
  firstname: api.firstname,
  lastname: api.lastname,
  email: api.email,
  companyLink: mapLinkableEntityType(api.companyLink),
  personLink: mapLinkableEntityType(api.personLink),
});
